import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import closeImg from '../../Images/close.svg';
import Checkbox from 'app/Components/Shared/CheckBox/Checkbox';
import '../Otp/OtpStage.scss';
import otpIcon from '../../Images/otp.svg';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import resendIcon from '../../Images/resend.svg';
import resendVoiceIcon from '../../Images/voice-resend.svg';
import FuntoneButton from '../../../../Components/FuntoneButton/FuntoneButton';

export default function OtpStageUI({
  phone,
  onSubmit,
  codeValue,
  error,
  onCodeChange,
  restrictedCodeValue,
  onRestrictedCodeChange,
  showRestricted,
  loading = false,
  resendLoading = false,
  onResend,
  onVoice,
  termsInd,
  termsAccepted,
  onTermsChange,
  termsError,
  onOpenTerms,
  restrictedCodeError,
}) {
  const handleResendClick = (e) => {
    e.preventDefault();
    if (onResend) onResend();
  };

  const handleVoiceClick = (e) => {
    e.preventDefault();
    if (onVoice) onVoice();
  };

  return (
    <form className='otp-stage-wrapper' onSubmit={onSubmit}>
      <div className='top-content'>
        <div className='image-container'>
          <Image src={otpIcon} className='image' alt='logo' />
        </div>
        <span className='title'>מה הקוד שקיבלת?</span>
        <TextInput
          className='input'
          name={'login-otp-input'}
          type='number'
          pattern='[0-9]*'
          id={'login-otp-input'}
          maxLength='6'
          autoComplete='off'
          placeholder='קוד אימות'
          value={codeValue}
          error={error}
          onChange={(e) => onCodeChange && onCodeChange(e.target.value)}
          disabled={loading}
        />
        <div className='login-popup-links'>
          <div className='login-popup-link-group'>
            <button type='button' className='login-popup-link' onClick={handleResendClick}>
              <Image className='image' src={resendIcon} alt='resend icon' />
              <span className='link'>לא קיבלתי קוד, תשלחו שוב</span>
            </button>

            <div className='login-popup-divider' />
            <button type='button' className='login-popup-link' onClick={handleVoiceClick}>
              <Image className='image' src={resendVoiceIcon} alt='resend icon' />
              <span className='link'>
                שלחו לי <br /> בהודעה קולית
              </span>
            </button>
          </div>
        </div>

        {showRestricted && (
          <div className='restricted-code-container'>
            <TextInput
              aria-label='restricted-code'
              className='restricted-input'
              placeholder='קוד זיהוי'
              value={restrictedCodeValue}
              onChange={(e) => {
                onRestrictedCodeChange && onRestrictedCodeChange(e.target.value);
                if (typeof onRestrictedCodeChange?.clearError === 'function') {
                  onRestrictedCodeChange.clearError();
                }
              }}
            />
            {restrictedCodeError && <div className='login-popup-restricted-error'>{restrictedCodeError}</div>}
          </div>
        )}

        {termsInd && (
          <div className='login-popup-terms'>
            <Checkbox
              id='login-terms-checkbox'
              checked={termsAccepted}
              onCheck={() => onTermsChange(true)}
              onUncheck={() => onTermsChange(false)}>
              <span className='login-popup-terms-text'>
                אישרתי את{' '}
                <span className='login-popup-terms-link' onClick={onOpenTerms}>
                  תקנון האתר
                </span>
              </span>
            </Checkbox>
          
          </div>
        )}
      </div>
      {termsError && <div className='login-popup-terms-error'>{termsError}</div>}
      <FuntoneButton text={loading ? 'טוען...' : 'בואו נתקדם'} variant='primary' type='submit' disabled={loading} />
    </form>
  );
}
